import { FederalState } from "../../GeneratedClients/FreeBillApi"

export type FederalStateChoice = {
  id: FederalState,
  name: string
}

export const federalStateChoices: FederalStateChoice[] = [
  { id: FederalState.BadenWuerttemberg, name: "Baden Württemberg" },
  { id: FederalState.Bayern, name: "Bayern" },
  { id: FederalState.Berlin, name: "Berlin" },
  { id: FederalState.Brandenburg, name: "Brandenburg" },
  { id: FederalState.Bremen, name: "Bremen" },
  { id: FederalState.Hamburg, name: "Hamburg" },
  { id: FederalState.Hessen, name: "Hessen" },
  { id: FederalState.MecklenburgVorpommern, name: "Mecklenburg Vorpommern" },
  { id: FederalState.Niedersachsen, name: "Niedersachsen" },
  { id: FederalState.Nrw, name: "Nordrhein Westfalen" },
  { id: FederalState.RheinlandPfalz, name: "Rheinland Pfalz" },
  { id: FederalState.Saarland, name: "Saarland" },
  { id: FederalState.Sachsen, name: "Sachsen" },
  { id: FederalState.SachsenAnhalt, name: "Sachsen Anhalt" },
  { id: FederalState.SchleswigHolstein, name: "Schleswig Holstein" },
  { id: FederalState.Thueringen, name: "Thüringen"}
]